import { useTranslation } from 'react-i18next';
import { TradingModal } from '@trading-ui/core';

import MoeveUserForm from '../forms/MoeveUserForm';

import { useMoeveUserForm } from '../../hooks/utils/useMoeveUserForm';

type Props = {
  actionId: number;
  setIsOpen: (actionId: number | null) => void;
  handleChangeActionStatus: (actionId: number, statusId: number, role?: string, companyId?: number) => void;
};

export default function MoeveUserModal({ actionId, setIsOpen, handleChangeActionStatus }: Props) {
  const { t } = useTranslation();

  const { form, isSubmitting, errors, updateRole, updateCompany, handleSubmit } = useMoeveUserForm({
    onSubmit: async (payload) => {
      handleChangeActionStatus(actionId, 2, payload.role, payload.company?.id);
      setIsOpen(null);
    },
  });

  return (
    <TradingModal
      titleText={t('settings.moeveActionsTab.moeveUserModal.title')}
      bodyText={
        <MoeveUserForm
          form={form}
          isSubmitting={isSubmitting}
          errors={errors}
          updateRole={updateRole}
          updateCompany={updateCompany}
          handleSubmit={handleSubmit}
        />
      }
      open
      onClose={() => setIsOpen(null)}
      styleModal={{
        minHeight: '30%',
        minWidth: '30%',
        overflow: 'visible',
      }}
      shouldCloseOnBackdropClick={false}
    />
  );
}
